import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';
import { toast } from 'sonner';

export const RESEND_INVITATION_MUTATION = gql`
  mutation ResendInvitation($email: String!) {
    resendInvitation(email: $email) {
      user {
        id
        email
        fullName
        role
        invitedAt
        createdAt
      }
    }
  }
`;

interface ResendInvitationResponse {
  resendInvitation: {
    user: {
      id: string;
      email: string;
      fullName: string;
      role: string;
      invitedAt: string;
      createdAt: string;
    };
  };
}

export function useResendInvitation(options?: { onCompleted?: () => void; onError?: (error: any) => void }) {
  const [resendInvitationMutation, { loading }] = useMutation<ResendInvitationResponse>(RESEND_INVITATION_MUTATION, {
    onCompleted: options?.onCompleted,
    onError: (error: any) => {
      if (options?.onError) {
        options.onError(error);
      } else {
        const message = error.graphQLErrors?.[0]?.message || error.message || 'Falha ao reenviar convite';
        toast.error(message);
      }
    },
  });

  const resendInvitation = (email: string) => {
    return resendInvitationMutation({
      variables: { email },
    });
  };

  return { resendInvitation, loading };
}
